"use strict";
import Cookies from "js-cookie";
import { i18n } from "./../main";


let loadedLanguages = ["en"]; // our default language that is preloaded

export const i18nCookieName = "_acquisition_lang";
// Create VueI18n instance with options

function setI18nLanguage(lang) {
  i18n.locale = lang;
  Cookies.set(i18nCookieName, lang, {
    expires: 3,
    sameSite: "strict",
    secure: true,
  });
  return lang;
}

export function loadLanguageAsync(lang) {
  // If the same language
  console.log("loadlanguageasync", lang, i18n.locale);
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang" */ `/src/lang/${lang}`).then(
    (messages) => {
      // console.log("messages", lang, messages);
      i18n.mergeLocaleMessage(lang, messages.default);
      loadedLanguages.push(lang);
      // console.log("after", lang, messages, i18n);

      return setI18nLanguage(lang);
    }
  );
}